import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminDashboard.css';
import axios from 'axios';

function AdminDashboard() {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('users');

    return (
        <div className="admin-dashboard container mt-5">
            <h1>Admin Dashboard</h1>
            
            <div className="admin-tabs">
                <button 
                    className={`tab-button ${activeTab === 'users' ? 'active' : ''}`}
                    onClick={() => setActiveTab('users')}
                >
                    User Management
                </button>
                <button 
                    className={`tab-button ${activeTab === 'orders' ? 'active' : ''}`}
                    onClick={() => setActiveTab('orders')}
                >
                    Order Management
                </button>
                <button 
                    className={`tab-button ${activeTab === 'products' ? 'active' : ''}`}
                    onClick={() => setActiveTab('products')}
                >
                    Product Management
                </button>
            </div>
            
            <div className="dashboard-content">
                {activeTab === 'users' ? (
                    <UserManagement />
                ) : activeTab === 'orders' ? (
                    <OrderManagement />
                ) : (
                    <div className="product-management">
                        <button 
                            className="action-button"
                            onClick={() => navigate('/admin/products/add')}
                        >
                            Add Product
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

// UserManagement component (your existing user table)
function UserManagement() {
    const [users, setUsers] = useState([]);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await axios.get('http://localhost:3001/admin/users', {
                    withCredentials: true
                });
                setUsers(response.data);
            } catch (error) {
                console.error("Failed to fetch users:", error);
            }
        };
        fetchUsers();
    }, []);

    return (
        <table className="table">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                </tr>
            </thead>
            <tbody>
                {users.map(user => (
                    <tr key={user._id}>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td>{user.role}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

function OrderManagement() {
    const [orders, setOrders] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const response = await axios.get('http://localhost:3001/admin/orders', {
                    withCredentials: true
                });
                setOrders(response.data);
            } catch (error) {
                console.error("Failed to fetch orders:", error);
            }
        };
        fetchOrders();
    }, []);


    const updateStatus = async (orderId, newStatus) => {
        try {
            await axios.put(
                `http://localhost:3001/admin/orders/${orderId}`,
                { status: newStatus },
                { withCredentials: true }
            );

            const response = await axios.get('http://localhost:3001/admin/orders', {
                withCredentials: true
            });
            setOrders(response.data);
        } catch (error) {
            console.error("Failed to update order:", error);
        }
    };

        return (
        <table className="table">
            <thead>
                <tr>
                    <th>Order ID</th>
                    <th>Customer</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {orders.map(order => (
                    <tr key={order._id}>
                        <td>{order._id.substring(0, 8)}...</td>
                        <td>{order.shippingAddress.name}</td>
                        <td>₹{order.total.toFixed(2)}</td>
                        <td>
                            <select 
                                value={order.trackingStatus}
                                onChange={(e) => updateStatus(order._id, e.target.value)}
                            >
                                <option value="Order Placed">Order Placed</option>
                                <option value="Dispatched">Dispatched</option>
                                <option value="In Transit">In Transit</option>
                                <option value="Out for Delivery">Out for Delivery</option>
                                <option value="Delivered">Delivered</option>
                            </select>
                        </td>
                        <td>
                            <button 
                                onClick={() => navigate(`/orders/${order._id}`, {state: {order}})}
                                className="btn btn-sm btn-info"
                            >
                                View
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default AdminDashboard;